import { useQuery } from '@tanstack/react-query';
import { IImageProps, Image } from '@zorro/web/design-system';
import { getEmployerLogo } from '@zorro/web/ui-utils';

/* eslint-disable id-length */

// Same size as Zorro logo on the right side
const LOGO_MAX_WIDTH = '2.5rem';
const LOGO_MAX_HEIGHT = '2.5rem';

const LOGO_HEIGHT_MINUS_TOP_BAR_VERTICAL_PADDING = 45;

type Props = Omit<IImageProps, 'alt'> & {
  logoUrl: string;
};

export const EmployerLogo = ({
  logoUrl,
  maw = LOGO_MAX_WIDTH,
  mah = LOGO_MAX_HEIGHT,
  h = LOGO_HEIGHT_MINUS_TOP_BAR_VERTICAL_PADDING,
  fit = 'contain',
  flex = '1 0 auto',
  ...props
}: Props) => {
  const { data: signedLogoUrl, isLoading } = useQuery({
    enabled: Boolean(logoUrl),
    queryKey: [logoUrl],
    queryFn: async () => {
      return await getEmployerLogo(logoUrl);
    },
  });

  if (isLoading || !signedLogoUrl || !logoUrl) {
    return null;
  }

  return (
    <Image
      h={h}
      maw={maw}
      mah={mah}
      fit={fit}
      flex={flex}
      src={signedLogoUrl}
      alt="Employer logo"
      style={{ borderRadius: '2px' }}
      {...props}
    />
  );
};
